import React from 'react';

import LineIcon from 'app/components/DeclarativeMap/LineIcon';
import PointIcon from 'app/components/DeclarativeMap/PointIcon';
import PolygonFilterIcon from 'app/components/DeclarativeMap/PolygonFilterIcon';

type OverlayGeometryIconProps =
  | { geometryType: 'Line'; color: string }
  | { geometryType: 'Point'; color: string }
  | { geometryType: 'Polygon'; color: string; filled: boolean; colors?: string[] };

const OverlayGeometryIcon: React.FunctionComponent<OverlayGeometryIconProps> = (props) => {
  if (props.geometryType === 'Line') {
    return <LineIcon color={props.color} size={24} />;
  } else if (props.geometryType === 'Point') {
    return <PointIcon color={props.color} size={24} />;
  } else {
    return (
      <PolygonFilterIcon
        color={props.color}
        fill={props.filled}
        size={24}
        colors={props.colors}
      />
    );
  }
};

export default OverlayGeometryIcon;
